import React, { useContext, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { useTranslate } from "react-polyglot";
import { useBaseData } from "../Data/BaseDataProvider.jsx";
import { useDialogs } from "../Common/DialogsProvider.jsx";
import { useAuth } from "../Auth/AuthProvider.jsx";

const PaymentContext = React.createContext(null);

/**
 * @returns {PaymentContext}
 */
export const usePayment = () => useContext(PaymentContext);

// eslint-disable-next-line require-jsdoc
const PaymentProvider = ({ children }) => {
  const t = useTranslate();
  const { requestPaymentHtml, preselectedOffer, setPreselectedOffer, userInfo, payHtml } = useBaseData();
  const { pathname } = useLocation();
  const snackbar = useDialogs();
  const { user } = useAuth();
  const [userValidPromoCode, setUserValidPromoCode] = useState("");

  /** */
  const pay = (id, promoCode) => {
    if (userInfo) {
      const existOffer = userInfo && userInfo.offers.find((offer) => offer.status === "pending");

      if (existOffer && !existOffer.paid && existOffer.offerId !== id) {
        return snackbar.warn(`${t("existOffer")}`);
      }
    }

    requestPaymentHtml(id, "offer", promoCode).then();
  };

  /** opening payment first time after login or register if offer was chosen */
  useEffect(() => {
    if (user && preselectedOffer) {
      pay(preselectedOffer);
      setPreselectedOffer(null);
    }
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [preselectedOffer, pathname]);

  // Переход по ссылке на оплату
  useEffect(() => {
    if (payHtml) {
      // for way 4 pay only payment form
      if (payHtml.type === "w4p") {
        const base64String = payHtml.data.split(",")[1];

        // eslint-disable-next-line no-undef
        const decodedBuffer = Buffer.from(base64String, "base64");

        // Конвертируем буфер в строку с кодировкой UTF-8
        const decodedString = decodedBuffer.toString("utf-8");

        const container = document.createElement("div");
        container.innerHTML = decodedString;

        const form = container.querySelector("form");

        if (form) {
          document.body.appendChild(container);
          form.submit();
        }
      } else {
        window.location.href = payHtml.data;
      }
    }
  }, [payHtml]);

  return (
    <PaymentContext.Provider value={{ pay, userValidPromoCode, setUserValidPromoCode }}>
      {children}
    </PaymentContext.Provider>
  );
};

export default PaymentProvider;
